module.exports = {
      id: "socialshare-usage",
      viewBox: "0 0 23.63 25.957",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#socialshare",
      toString: function () {
        return this.url;
      }
    }